module.exports = __webpack_public_path__ + "static/line-yellow-4abf483e7f9266d91e5a66e872a5bdc9.svg";